import {useEffect, useState} from 'react';
import {ITermsItem} from '../type';

interface IProps {
  termsList: ITermsItem[];
}

export default function useCheckTerms({termsList}: IProps) {
  const [termsCheckedObj, setTermsCheckedObj] = useState<{
    [key: number]: boolean;
  }>({});
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);

  useEffect(() => {
    setIsAllChecked(termsList.every(({id}) => termsCheckedObj[id]));
  }, [termsList, termsCheckedObj]);

  useEffect(() => {
    setIsConfirmEnabled(
      !!termsList.length &&
        termsList
          .filter(({isRequired}) => isRequired)
          .every(({id}) => termsCheckedObj[id])
    );
  }, [termsList, termsCheckedObj]);

  const getAccepted = () => {
    return termsList
      .filter(({id}) => termsCheckedObj[id])
      .map(item => item.id)
      .join(',');
  };

  return {
    termsCheckedObj,
    setTermsCheckedObj,
    isAllChecked,
    isConfirmEnabled,
    getAccepted,
  };
}
